$(document).ready(function(){
	var $carousel = $(".slider-gallery");
	$('ul.tabs li a').click(function(event){
		
   setTimeout(function() {
    $carousel.show()
      // resize after un-hiding Flickity
      .flickity("resize");
  }, 10);
		
      /*var selector = event.target.getAttribute('href');
      console.log(selector);
  // trigger resize on tab pane
    $(  selector + " .slider-gallery ").flickity();
    $(  selector + " .slider-gallery ").flickity('resize');*/
    //$ ( "#tab2 .flickity-button").trigger('click');
  
    
   });
})

const elements = document.querySelectorAll('.product-color-swatch');
console.log(elements.length);
if (elements !== null) {
var paragraph = document.getElementById("show-more-swatch");
  if (paragraph !== null) {
      var count = elements.length - 5 ;
      var text = document.createTextNode("+" + count);
      paragraph.appendChild(text);
  }
elements.forEach((element,index) => {
  
  if (index >= 4){
    element.classList.add('more-swatch');
  }

});
}
$(document).ready(function(){

   
    $('#show-more-swatch').click(function(event) {
      event.preventDefault();
      $('.more-swatch').css("display","block");
      $('#show-more-swatch').css("display","none");
      $('.show-more-close').css("display","block");
    });
   $('.show-more-close').click(function() {
      $('.more-swatch').css("display","none");
      $('#show-more-swatch').css("display","block");
      $('.show-more-close').css("display","none");
    });

   $('#show-more-swatch-products').click(function(event) {
      event.preventDefault();
      $('.more-swatch').css("display","block");
      $('#show-more-swatch-products').css("display","none");
      $('.show-more-close').css("display","block");
    });
   $('.show-more-close').click(function() {
      $('.more-swatch').css("display","none");
      $('#show-more-swatch-products').css("display","block");
      $('.show-more-close').css("display","none");
    });
});



var elem = document.querySelector('.icon-bars');
var flkty = new Flickity( elem, {
 wrapAround: true,
  pageDots: false,
  initialIndex: 1,
  fade: true,
  watchCSS: true,
  prevNextButtons: false,
  accessibility: true, //true by default
  autoPlay: true // advance cells every 3 seconds
});

$(document).ready(function(){
   $(".mobile-menu__list-item").click(function(){
      setTimeout(function () {
        $('body').addClass('sub-mobile-menu--opened');
        
      }, 10);
   });
   $(".mobile-submenu__lable").click(function(){
       setTimeout(function () {
        
        $('body').removeClass('sub-mobile-menu--opened');
      }, 50);
   });
  
});




$(document).ready(function() {
  var $thumbSlider = $('.js-gallery-carousel');
  var $mainGallery = $('.product-gallery__main');

  // Only run if the thumbnail slider isn't already initialized by the theme
  if ($thumbSlider.length > 0 && !$thumbSlider.hasClass('flickity-enabled')) {
    $thumbSlider.flickity({
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: true,
      wrapAround: false
    });
  }

  // Click a thumbnail -> select matching main slide (works desktop + mobile)
  $thumbSlider.on('click', '.product-gallery__thumbnail', function() {
    var index = $(this).index();
    if ($mainGallery.data('flickity')) {
      $mainGallery.flickity('select', index);
    }
  });
});

/*(function () {
  let lastScrollTop = 0;
  const header = window.innerWidth <= 989
    ? document.getElementById('mobile-header')
    : document.getElementById('header');

  const announcement = document.querySelector('.announcement-bar__container_sticky');

  if (!header) return;

  window.addEventListener('scroll', function () {
    const st = window.scrollY || document.documentElement.scrollTop;

    if (st <= 2) {
      header.classList.add('header-top-class');
    } else {
      header.classList.remove('header-top-class');
    }

    if (st > lastScrollTop && st > 10) {
      header.classList.add('hide');
      if (announcement) announcement.classList.add('hide');
    } else {
      header.classList.remove('hide');
      if (announcement) announcement.classList.remove('hide');
    }

    lastScrollTop = st <= 0 ? 0 : st;
  }, { passive: true });
})();*/